import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { PrudsysProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/PrudsysProductsRecommendationsFragmentDoc';
import { PrudsysProductsRecoSlider } from '@packages/recommendations';
import { useIntl } from 'react-intl';
import { useHashParameters } from '../../hooks/useHashParameters';
import { fallbackPrudsysHeadline } from './messages';

/* GraphQL */ `
  fragment PrudsysProductsRecommendations on Product {
    defaultCategory
    orderNumber
    brand {
      name
    }
  }
`;

export type PrudsysProductsRecommendationsProps = {
  data: FragmentType<typeof PrudsysProductsRecommendationsFragmentDoc>;
};

/**
 * The `PrudsysProductsRecommendations` component is used as a wrapper for the `PrudsysProductsRecoSlider` component.
 * It displays the recommendations for the prudsysProducts Query.
 * */
export const PrudsysProductsRecommendations = ({ data }: PrudsysProductsRecommendationsProps) => {
  const { orderNumber, brand, defaultCategory } = getFragmentData(
    PrudsysProductsRecommendationsFragmentDoc,
    data,
  );

  const { category = '' } = useHashParameters();
  const { formatMessage } = useIntl();

  return (
    <PrudsysProductsRecoSlider
      brand={brand?.name ?? ''}
      categoryIds={[defaultCategory ?? category]}
      productId={orderNumber}
      pageTemplate="detailview"
      fetchOnThreshold
      elementIndex={0}
      title={formatMessage(fallbackPrudsysHeadline)}
      key={`${orderNumber}${0}`}
    />
  );
};
